/**
 * Created by pajicv on 10/8/18.
 */
import React from 'react';
import { Button, Typography, withStyles, TextField } from '@material-ui/core';
import Download from '@material-ui/icons/CloudDownload';
const styles = theme => ({
  disabledButton: {
    opacity: 0.3,
    color: '#ccc'
  },
  row: {
    display: 'flex',
    flexDirection: 'row'
  },
  rowOne: {
    display: 'flex',
    flexDirection: 'row',
    marginTop: 20
  },
  rowWorker: {
    display: 'flex',
    flexDirection: 'column',
  },
  text: {
    padding: 15
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    marginTop: 40,
    width: 400
  },

});

class DownloadDocumentButton extends React.Component {

  render() {
    const isUrlReady = true;
    const { classes, document, worker, description } = this.props;
    if (isUrlReady) {
      return (
        <div className={worker ? classes.rowWorker : classes.row}>
          {worker &&
            <TextField
              label="Beschreibung"
              multiline
              className={classes.textField}
              variant='outlined'
              rows="4"
              disabled={worker}
              margin="normal"
              InputLabelProps={{
                shrink: true,
              }}
              value={description}
            />
          }
          {document &&
            <div className={classes.rowOne}>
              <Button
                variant="fab"
                color="primary"
                aria-label="Download"
                target="_blank"
                href={document}
              >
                <Download />
              </Button>
              <Typography className={classes.text}>Download Template</Typography>
            </div>
          }
        </div>
      );
    }
    return (
      <Button
        aria-label="Download"
        className={classes.disabledButton}
        variant="contained"
        disabled
      >
        <Typography>Persona Template</Typography>
      </Button>
    );
  }
}

export default withStyles(styles)(DownloadDocumentButton);



// WEBPACK FOOTER //
// ./src/components/Tasks/DownloadDocumentButton.js